import { render, staticRenderFns } from "./SubFrame.vue?vue&type=template&id=02967040&scoped=true&"
import script from "./SubFrame.vue?vue&type=script&lang=js&"
export * from "./SubFrame.vue?vue&type=script&lang=js&"
import style0 from "./SubFrame.vue?vue&type=style&index=0&id=02967040&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02967040",
  null
  
)

export default component.exports